import Container from '../../atoms/container/searchKeyboardContainer';
import Direction from '../../../../shared/types/enums/direction';
import Focus from '../../../../shared/types/enums/focus';
import LettersKeyboard from '../../sections/virtualKeyboard/searchKeyboard';
import NumbersKeyboard from '../../sections/virtualKeyboard/numbersKeyboard';
import Queries from '../../elements/search/searchQueries';
import useTransform from '../../../../shared/components/utils/hooks/useTransform';
import { AutoComplete } from '@shared/types/interfaces/search';
import { focusSelector } from '../../../../shared/store/slices/focus.slice';
import { useAppSelector } from '../../../../shared/store/hooks';
import { useEffect, useState } from 'react';

const OFFSET = 350;

interface Props {
  actions: {
    clearAction: () => void;
    searchAction: () => void;
    onChangeElement: () => void;
    onChangeInput: () => void;
    onDeleteInput: () => void;
    outOfBoundsAction: () => void;
  };
  queries: AutoComplete[];
}

enum KEYBOARDS {
  Letters,
  Numbers,
}

function SearchKeyboard({ actions, queries }: Props) {
  const { focus } = useAppSelector(focusSelector);
  const {
    clearAction,
    searchAction,
    onChangeInput,
    onDeleteInput,
    outOfBoundsAction,
  } = actions;

  const [style, , ,] = useTransform(0, OFFSET, Direction.VERTICAL);
  const [selectedKeyboard, setSelectedKeyboard] = useState(KEYBOARDS.Letters);
  const KeyboardComponent =
    selectedKeyboard === KEYBOARDS.Letters ? LettersKeyboard : NumbersKeyboard;

  useEffect(() => {
    if (focus === Focus.MENU || focus === Focus.LOGIN) {
      return;
    }
    // This animates the transition between keyboard and autocomplete, it has been removed from design but let's keep it in case we want it again
    // if (focus === Focus.QUERY_LIST) {
    //   setStyle(1);
    // } else {
    //   setStyle(0);
    // }
  }, [focus]);

  return (
    <Container animation={'search-keyboard-scroll'} style={style}>
      <KeyboardComponent
        clearAction={clearAction}
        searchAction={searchAction}
        onChange={onChangeInput}
        onDelete={onDeleteInput}
        outOfBounds={outOfBoundsAction}
        swapKeyboardAction={setSelectedKeyboard}
      />
      <Queries
        queries={queries}
        action={searchAction}
        outOfBounds={outOfBoundsAction}
      />
    </Container>
  );
}

export { KEYBOARDS };
export default SearchKeyboard;
